import { Navigate, useLocation } from 'react-router-dom'

/**
 * A redirect that keeps the address's query string and hash, so a short link
 * such as `/integrations/suggestions?connection=...` lands on the same view.
 *
 * @param {{to: string}} props - the target path, without a query string
 * @returns {JSX.Element}
 */
export default function NavigateKeepingQuery({ to }) {
  const { search, hash } = useLocation()
  return <Navigate to={{ pathname: to, search, hash }} replace />
}
